import { createContext, FC, PropsWithChildren, useState } from 'react'

export interface IGlobalContext {
  pageHeight: string
  setHeaderHeightInPx: (height: number) => void
}

const defaultValues: IGlobalContext = {
  pageHeight: 'clac(100vh - 64px)',
  setHeaderHeightInPx: () => {},
}

export const GlobalContext = createContext<IGlobalContext>(defaultValues)

const GlobalContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [headerHeightInPx, setHeaderHeightInPx] = useState(64)

  return (
    <GlobalContext.Provider
      value={{
        pageHeight: `calc(100vh - ${headerHeightInPx}px)`,
        setHeaderHeightInPx,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

export default GlobalContextProvider
